import React, { useCallback, useEffect, useState } from 'react';
import { Card, Row, Col, Space, Typography, Switch, message, Alert, Button } from 'antd';
import { ExperimentOutlined, ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../services/api';

const { Title, Text } = Typography;

const AdminFeatures = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/admin/player-features');
      setSettings(r.data);
    } catch (err) {
      message.error('Erro: ' + (err.response?.data?.error || err.message));
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const togglePlayerStats = async (val) => {
    setSaving(true);
    try {
      const r = await api.patch('/admin/player-features', { stats_enabled: val });
      setSettings(r.data);
      message.success(val ? 'Player Stats ATIVADO' : 'Player Stats DESATIVADO');
    } catch (err) {
      message.error('Erro: ' + (err.response?.data?.error || err.message));
    } finally { setSaving(false); }
  };

  return (
    <div style={{ padding: 24 }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={3} style={{ margin: 0 }}>
            <ExperimentOutlined /> Features controladas
          </Title>
          <Text type="secondary">Toggles pra liberar funcionalidades novas ou beta pra usuários.</Text>
        </Col>
        <Col>
          <Button icon={<ReloadOutlined />} onClick={load} loading={loading}>Atualizar</Button>
        </Col>
      </Row>

      <Card size="small" style={{ marginBottom: 16 }}>
        <Row align="middle" gutter={16}>
          <Col flex="auto">
            <Space direction="vertical" size={0}>
              <Text strong style={{ fontSize: 16 }}>📊 Estatísticas do jogador</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Adiciona card no dashboard do jogador com frequência, rating recebido e histórico. MVP e stats esportivas (gols/cartões) virão nas próximas iterações.
              </Text>
            </Space>
          </Col>
          <Col>
            <Switch
              checked={!!settings?.stats_enabled}
              onChange={togglePlayerStats}
              loading={saving}
              checkedChildren="ON"
              unCheckedChildren="OFF"
            />
          </Col>
        </Row>
        {settings?.updated_at && (
          <Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 8 }}>
            Última mudança: {dayjs(settings.updated_at).format('DD/MM/YYYY HH:mm')} por {settings.updated_by || '—'}
          </Text>
        )}
      </Card>

      {settings && !settings.stats_enabled && (
        <Alert
          type="info"
          showIcon
          message="Estatísticas ocultas pros jogadores"
          description="Enquanto desligado, a tela do jogador não mostra o card de estatísticas. API retorna 403 pra evitar consumo indevido."
        />
      )}
    </div>
  );
};

export default AdminFeatures;
